import { ValidationChange } from './action-types';
import { SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { userSettingsTranslations } from './constants';
import { STATE } from 'app/constants';
import { errorSafe } from 'app/infrastructure/redux';
import * as simpleFormActions from 'app/infrastructure/simple-form/actions';
import { createDescriptionSelector } from 'app/infrastructure/translate/index';
import { validationFromServer } from 'app/infrastructure/data/validation';
import * as shellActions from 'app/shell/default/actions';
import { api } from './api';
import { ActionDispatching } from 'app/types-shared';

const simpleFormActionCreators = simpleFormActions.actionCreators(STATE.userSettings);

export const actionCreators = {

  /**
   * Component can save profile data
   */
  saveChanges: (query): ActionDispatching<any, any> => async (dispatch: any, getState: any) => {
    const translate = createDescriptionSelector(getState().userSettings.texts);
    try {
      const result = await api.saveSettings(query) as any;
      if (result) {
        await dispatch(simpleFormActionCreators.resetChangesListener());
        const state = getState();
        // Check if language has changed
        if (query.language && (query.language.v !== state.app.userInfo.language.value)) {
          setTimeout(() => window.location.search = '', 100);
        } else {
          // Load user info again to update the user info in the app state and shell config
          dispatch(shellActions.actionCreators.loadUserInfo());
          await dispatch(new SuccessNotification(translate(userSettingsTranslations.profile_saved)));
        }
      }
    } catch (err) {
      dispatch(new ValidationChange(err.validationErrors ? validationFromServer(err.validationErrors) : []));
    }
  },

  changePassword: (query): ActionDispatching<any, any> => async (dispatch: any, getState: any) => {
    const translationDescription = createDescriptionSelector(getState().userSettings.texts);
    try {
      const result = await api.changePassword(query) as any;
      if (result) {
        dispatch(shellActions.actionCreators.removeModal());
        dispatch(new SuccessNotification(translationDescription(userSettingsTranslations.password_changed)));
        dispatch(shellActions.actionCreators.displayModal(''));
      }
    } catch (err) {
      dispatch(new ValidationChange(err.validationErrors ? validationFromServer(err.validationErrors) : []));

    }
  },

  displayModal: (name: string): ActionDispatching<any, any> => errorSafe(async (dispatch: any, getState: any) => {
    dispatch(simpleFormActionCreators.validationClear());
    dispatch(new ValidationChange([]));
    dispatch(shellActions.actionCreators.displayModal(name));
  }),

  clearValidation: ():ActionDispatching<any, any> => errorSafe(async (dispatch: any, getState: any) => {
    dispatch(simpleFormActionCreators.validationClear());
    dispatch(new ValidationChange([]));
  })
};
